import axios from "axios";
import {getUserToken} from "../../../../../utils/functions/userToken";
import {apiUrlActiveMultipliers} from "./apiUrlActiveMultipliers";

export const deleteMultipliers = async (bids, platform, idAccount, hotelsOrGroup) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.post(
            `${apiUrlActiveMultipliers['platform'][hotelsOrGroup][platform]}${idAccount}/`,
            { bids },
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch campaign details";
        return { success: false, error: errorMessage };
    }
};

